import Video2Icon from "../Icons/Video2Icon";
import PdfIcon from "../Icons/PdfIcon";
import QuestionMarkIcon from "../Icons/QuestionMarkIcon";
import { LectureByIdDTO } from "../../api/Lecture/GetLecturerById";
import { Link } from "react-router-dom";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../Shared/accordion";
import GreenCheckIcon from "../Icons/GreenCheckIcon";
import { formatDuration } from "../../hooks/DurationConverter";

const ContentAccordion = ({
  lectureName,
  onClick,
  isActive,
  data,
  onVideoSelect,
  activeVideoUrl,
  itemId,
  onQuizSelect,
  onEssaySelect,
  activeQuizUrl,
  activeEssayUrl,
  onExamSelect,
  activeExamUrl,
  lectureTime,
}: {
  lectureName?: string;
  data?: LectureByIdDTO;
  onClick?: () => void;
  isActive?: boolean;
  onVideoSelect: (
    videoUrl: string,
    videoId: string,
    otp: string,
    playback: string,
    name: string
  ) => void;
  activeVideoUrl: string;
  itemId: string;
  onQuizSelect: (quizId: string, quizTitle: string) => void;
  onEssaySelect: (quizId: string, quizTitle: string) => void;
  activeQuizUrl: string;
  activeEssayUrl: string;
  onExamSelect: (quizId: string, quizTitle: string, mcqId: string) => void;
  activeExamUrl: string;
  lectureTime?: string;
}) => {
  const quizizz = data?.quizizz ?? [];
  const quizEssay = data?.QuizEssay ?? [];
  const resources = data?.resources ?? [];
  const videos = data?.videos ?? [];
  const exam = data?.Exam ?? [];
  const ifrs = data?.Ifrs ?? [];

  // Helper function to format seconds to HH:MM:SS

  return (
    <AccordionItem id="lecture" value={itemId}>
      <AccordionTrigger
        className={`accordionTrigger relative text-sm sm:text-base font-semibold flex justify-between gap-2`}
        onClick={onClick}
      >
        <span className="text-start">{lectureName}</span>
        <span className="text-sm mr-5">{lectureTime}</span>
      </AccordionTrigger>
      <AccordionContent>
        <div className="space-y-4">
          {videos.map((video) => (
            <div
              key={video.id}
              onClick={() =>
                onVideoSelect(
                  video.url,
                  video.id,
                  video.cipher.otp,
                  video.cipher.playbackInfo,
                  video.name
                )
              }
              className={`flex gap-2 border-l-[3.6px] py-2 pr-4 pl-3 cursor-pointer transition-all duration-300 ease-in-out ${
                activeVideoUrl === video.url
                  ? "bg-[#EFF9FF] border-primary"
                  : "border-transparent"
              }`}
            >
              <div
                className={`${
                  isActive ? "text-primary" : "border-transparent"
                }`}
              >
                {video.watched ? <GreenCheckIcon /> : <Video2Icon />}
              </div>
              <div className="flex justify-between w-full">
                <p className="text-lightGray">
                  <span
                    className={`${
                      video.watched ? "!text-green-500" : ""
                    } font-semibold text-sm sm:text-lg ${
                      isActive ? "text-primary" : "text-lightGray"
                    }`}
                  >
                    Video :
                  </span>
                  {video.name}
                </p>
                <p className="text-sm">
                  {formatDuration(Number(video.duration))}
                </p>
              </div>
            </div>
          ))}
          {resources.map((resource) => (
            <div
              key={resource.id}
              className="flex gap-2 items-center border-l-[3.6px] border-transparent py-2 pr-4 pl-3 cursor-pointer"
            >
              <PdfIcon />
              <Link
                target="_blank"
                to={resource.url}
                className="text-lightGray"
              >
                <span className="font-semibold text-sm sm:text-lg text-bruntBlack">
                  PDF :
                </span>
                {resource.title}
              </Link>
            </div>
          ))}
          {ifrs.map((ifrs) => (
            <div
              key={ifrs.id}
              className="flex gap-2 border-l-[3.6px] border-transparent items-center py-2 pr-4 pl-3 cursor-pointer"
            >
              <QuestionMarkIcon />
              <Link
                target="_blank"
                to={`/ifrs-exam/${ifrs.id}`}
                className="text-lightGray"
              >
                <span className="font-semibold text-sm sm:text-lg text-bruntBlack">
                  Quiz :
                </span>
                {ifrs.title}
              </Link>
            </div>
          ))}
          {quizizz.map((quiz) => (
            <div
              key={quiz.id}
              onClick={() => onQuizSelect(quiz.id, quiz.title)}
              className={`flex gap-2 items-center border-l-[3.6px] py-2 pr-4 pl-3 cursor-pointer ${
                activeQuizUrl === quiz.id
                  ? "bg-[#EFF9FF] border-primary"
                  : "border-transparent"
              }`}
            >
              <QuestionMarkIcon />
              <div className="text-lightGray">
                <span className="font-semibold text-sm sm:text-lg text-bruntBlack">
                  Quiz :
                </span>
                {quiz.title}
              </div>
            </div>
          ))}
          {quizEssay.map((quiz) => (
            <div
              key={quiz.id}
              onClick={() => onEssaySelect(quiz.id, quiz.title)}
              className={`flex gap-2 items-center border-l-[3.6px] py-2 pr-4 pl-3 cursor-pointer ${
                activeEssayUrl === quiz.id
                  ? "bg-[#EFF9FF] border-primary"
                  : "border-transparent"
              }`}
            >
              <QuestionMarkIcon />
              <div className="text-lightGray">
                <span className="font-semibold text-sm sm:text-lg text-bruntBlack">
                  Essay Quiz :
                </span>
                {quiz.title}
              </div>
            </div>
          ))}
          {exam.map((quiz) => (
            <div
              key={quiz.id}
              onClick={() => onExamSelect(quiz.id, quiz.title, quiz.quizId)}
              className={`flex gap-2 items-center border-l-[3.6px] py-2 pr-4 pl-3 cursor-pointer ${
                activeExamUrl === quiz.id
                  ? "bg-[#EFF9FF] border-primary"
                  : "border-transparent"
              }`}
            >
              <QuestionMarkIcon />
              <div className="text-lightGray">
                <span className="font-semibold text-sm sm:text-lg text-bruntBlack">
                  Mixed Exam :
                </span>
                {quiz.title}
              </div>
            </div>
          ))}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};

export default ContentAccordion;
